import { DataTags } from 'components/DataTags';
import { type TColumns } from 'hooks/useSortColumnsModal';
import { EFieldType, EOperator } from '@timeedit/types/lib/enums';

export const allowedFieldTypeMatching: [EFieldType, EFieldType][] = [
  [EFieldType.INTEGER, EFieldType.INTEGER],

  [EFieldType.CHECKBOX, EFieldType.CHECKBOX],

  [EFieldType.TEXT, EFieldType.TEXT],
  [EFieldType.TEXT, EFieldType.SIGNATURE],
  [EFieldType.TEXT, EFieldType.REFERENCE],
  [EFieldType.TEXT, EFieldType.CATEGORY],

  [EFieldType.SIGNATURE, EFieldType.TEXT],
  [EFieldType.SIGNATURE, EFieldType.SIGNATURE],
  [EFieldType.SIGNATURE, EFieldType.REFERENCE],
  [EFieldType.SIGNATURE, EFieldType.CATEGORY],

  [EFieldType.REFERENCE, EFieldType.TEXT],
  [EFieldType.REFERENCE, EFieldType.SIGNATURE],
  [EFieldType.REFERENCE, EFieldType.REFERENCE],
  [EFieldType.REFERENCE, EFieldType.CATEGORY],

  [EFieldType.CATEGORY, EFieldType.TEXT],
  [EFieldType.CATEGORY, EFieldType.SIGNATURE],
  [EFieldType.CATEGORY, EFieldType.REFERENCE],
  [EFieldType.CATEGORY, EFieldType.CATEGORY],
];

export const availableFieldRelationTypes: EFieldType[] = [
  EFieldType.INTEGER,
  EFieldType.TEXT,
  EFieldType.CATEGORY,
  EFieldType.CHECKBOX,
  EFieldType.SIGNATURE,
  EFieldType.REFERENCE,
];

export const fieldTypeInputMapping: Record<EFieldType, TInputType> = {
  [EFieldType.INTEGER]: 'number',
  [EFieldType.TEXT]: 'text',
  [EFieldType.CATEGORY]: 'select',
  [EFieldType.CHECKBOX]: 'switch',
  [EFieldType.COMMENT]: 'textarea',
  [EFieldType.EMAIL]: 'text',
  [EFieldType.LENGTH]: 'number',
  [EFieldType.NON_SEARCHABLE_REFERENCE]: 'text',
  [EFieldType.NON_SEARCHABLE_TEXT]: 'text',
  [EFieldType.REFERENCE]: 'text',
  [EFieldType.TELEPHONE]: 'text',
  [EFieldType.SIGNATURE]: 'text',
  [EFieldType.URL]: 'text',
};

export const integerOperator: Record<EOperator, string> = {
  [EOperator.E]: 'Equals',
  [EOperator.GT]: 'Greater Than',
  [EOperator.GTE]: 'Greater Than or Equals',
  [EOperator.LT]: 'Less Than',
  [EOperator.LTE]: 'Less Than or Equals',
};

export type TInputType = 'number' | 'text' | 'select' | 'switch' | 'textarea';

export type TFieldRowData = {
  id: number;
  name: string;
  extId: string;
  types: number[];
  objectTypes: string[];
  fieldType: string;
};

export const FIELD_COLUMNS = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 80,
    ellipsis: true,
    sorter: (a: TFieldRowData, b: TFieldRowData) => a.id - b.id,
  },
  {
    title: 'Ext. ID',
    dataIndex: 'extId',
    key: 'extId',
    ellipsis: true,
    sorter: (a: TFieldRowData, b: TFieldRowData) =>
      a.extId.localeCompare(b.extId),
  },
  {
    title: 'Field name',
    dataIndex: 'name',
    key: 'name',
    ellipsis: true,
    sorter: (a: TFieldRowData, b: TFieldRowData) =>
      a.name.localeCompare(b.name),
  },
  {
    title: 'Type',
    dataIndex: 'fieldType',
    key: 'fieldType',
    ellipsis: true,
    sorter: (a: TFieldRowData, b: TFieldRowData) =>
      a.fieldType.localeCompare(b.fieldType),
  },
  {
    title: 'Object Type',
    dataIndex: 'objectTypes',
    key: 'objectTypes',
    render: (objectTypes: string[]) => <DataTags data={objectTypes} />,
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description',
    ellipsis: true,
  },
];
